<template>
    <el-dialog :title="title" :visible="dialogFormVisible" width="30%" :before-close="handleClose" :closeOnClickModal="false">
        <el-form label-width="80px" ref="model" :model="model" :rules="rules">
            <el-form-item label="用户姓名" prop="UserName">
                <el-input size="small" v-model="model.UserName" auto-complete="off" placeholder="请输入姓名" maxlength="100"></el-input>
            </el-form-item>
            <el-form-item label="用户密码" prop="UserPwd">
                <el-input size="small" v-model="model.UserPwd" auto-complete="off" placeholder="请输入密码" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='handleClose'>取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="handleSave">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {
        UpdateAdmin
    } from '../../api/user'
    export default {
        data() {
            return {
                title: '编辑用户',
                name: 'add',
                loading: false,

                model: {
                    UserId: null,
                    UserName: '',
                    UserPwd: ''
                },
                rules: {
                    UserName: [{
                        required: true,
                        message: '请输入用户姓名',
                        trigger: 'blur'
                    }],
                },
            }
        },
        props: {
            dialogFormVisible: {
                required: true,
                type: Boolean
            },
            data: {
                required: true,
                type: Object
            }
        },
        mounted() {
            this.model = this.data;
        },
        methods: {
            handleSave() {
                this.$refs.model.validate((valid) => {
                    if (valid) {
                        if (this.model.UserPwd) {
                            let res = this.done(this.model.UserPwd);
                            if (res) {
                                this.UpdateAdmin();
                            } else {
                                this.$message({
                                    message: '密码只能包含数字或者字母',
                                    type: 'warning'
                                });
                            }
                        }else{
                            this.UpdateAdmin();
                        }
                    } else {
                        this.$message({
                            message: '请填写完整信息',
                            type: 'warning'
                        });
                    }
                });
            },
            handleClose() {
                this.$emit('closeEditDialog')
            },
            UpdateAdmin() {
                UpdateAdmin(this.model).then(data => {
                    if (!data.iserror) {
                        this.loading = false;
                        this.$message({
                            message: '更新成功',
                            type: 'success'
                        });
                        this.handleClose();
                    }
                })
            },
            done(input) {
                var regex = /^[0-9A-Za-z]+$/;
                if (input.match(regex)) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
</script>

<style>

</style>